import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ConsigneesApi } from 'api';

/**
 *  Custom React Query hook to update a consignee
 *
 * @param {number} id
 * @param {{ onSuccess?: () => void; onError?: (error: Error) => void }} options
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
export const useUpdateConsignee = (id, { onSuccess, onError } = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => ConsigneesApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['consignees']);
      typeof onSuccess === 'function' && onSuccess();
    },
    onError: (error) => {
      typeof onError === 'function' && onError(error);
    },
  });
};
